import React from 'react';
import { SearchBox } from '../../../Search/SearchBox';
import { jsx as _jsx } from "react/jsx-runtime";
export function DefaultColumnFilter(_ref) {
  let {
    column: {
      id,
      filterValue,
      setFilter
    }
  } = _ref;
  const searchBoxRef = React.useRef(null);
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      var _searchBoxRef$current;
      (_searchBoxRef$current = searchBoxRef.current) === null || _searchBoxRef$current === void 0 || (_searchBoxRef$current = _searchBoxRef$current._inputElement) === null || _searchBoxRef$current === void 0 || _searchBoxRef$current.current.focus();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);
  return /*#__PURE__*/_jsx(SearchBox, {
    componentRef: searchBoxRef,
    ariaLabel: "Filter by text",
    placeholder: 'Filter ' + id,
    onAbort: () => setFilter(undefined),
    onChange: (_event, value) => setFilter(value),
    value: filterValue,
    styles: {
      root: {
        width: 200
      }
    }
  });
}